import React from "react";
import IconLock from "../icon/IconLock";
import NonInteractiveIcon from "./NonInteractiveIcon";

export default function InstructionSection({instructions, onChange}) {

  const updateInstructions = (e) => {
    onChange(e.target.value)
  }

  return (
    <div className="bg-white px-4 py-5 mb-3 rounded-lg p-6">
      <div className="md:grid md:grid-cols-12 md:gap-6">
        <div className="md:col-span-4">
          <NonInteractiveIcon>
            <IconLock/>
          </NonInteractiveIcon>
          <span className="font-bold">Instructions</span>
        </div>
        <div className="md:col-span-7">
          <textarea className='rounded-md block w-full text-sm transition duration-150 ease-in-out'
                    placeholder='Enter instructions for visitors on how to fill in the form'
                    value={instructions ? instructions : ''}
                    rows={3} onChange={(e) => updateInstructions(e)}/>
        </div>
      </div>
    </div>
  )
}
